import type { EWalletType, IMessage } from '@dev-fast/types';

import type { IGetDoubleJackpotHistory } from '../../types';
import { createTipleJackpotChatMessage } from './create-triple-jackpot-chat-message';

export const getChatHistoryMessagesAdapter = (jackpotHistory: IGetDoubleJackpotHistory, walletType: EWalletType): IMessage | null => {
  if (jackpotHistory?.jackpots?.length) {
    const jackpot = jackpotHistory.jackpots[0];
    return createTipleJackpotChatMessage({
      timestamp: jackpot.timestamp,
      amount: +(jackpot.amount ?? 0),
      winnersCount: jackpot.unique_winners_count,
      walletType: walletType,
    });
  }
  return null;
};
